/**
 * Handover-email domain API (K1c-2).
 *
 * Preview + send the SIGNED handover documents (inspection protocols + key
 * receipt) to a tenancy's primary tenant. Backend is the source of truth for
 * recipient, sendable documents and can_send. Mirrors the other adminData
 * domain modules (auth via getApiHeaders, errors via parseAdminErrorResponse).
 */
import { API_BASE_URL, getApiHeaders, parseAdminErrorResponse } from "./core";

/** GET /api/admin/tenancies/{tenancyId}/handover-email/preview */
export async function getHandoverEmailPreview(tenancyId) {
  const res = await fetch(
    `${API_BASE_URL}/api/admin/tenancies/${encodeURIComponent(tenancyId)}/handover-email/preview`,
    { headers: getApiHeaders() }
  );
  if (!res.ok) {
    const detail = await parseAdminErrorResponse(res);
    throw new Error(detail || "Vorschau konnte nicht geladen werden.");
  }
  return res.json();
}

/** POST /api/admin/tenancies/{tenancyId}/handover-email/send */
export async function sendHandoverEmail(tenancyId) {
  const res = await fetch(
    `${API_BASE_URL}/api/admin/tenancies/${encodeURIComponent(tenancyId)}/handover-email/send`,
    { method: "POST", headers: getApiHeaders() }
  );
  if (!res.ok) {
    const detail = await parseAdminErrorResponse(res);
    throw new Error(detail || "E-Mail konnte nicht versendet werden.");
  }
  return res.json();
}
